module.exports = __webpack_public_path__ + "static/media/twist.3be62546.png";